/**
 * The OIDC Grant TTL, in days: the longest any grant (and so any refresh token) can live.
 *
 * AB#7690 (iQuantiv): upstream hard-codes 180 days. `OIDC_GRANT_TTL_DAYS` raises or lowers it;
 * unset (or empty) keeps upstream's 180. Read once, when this module loads. In a browser bundle
 * (the console) there is no `process`, so the console keeps showing upstream's 180 as the
 * refresh-token maximum; the server enforces the configured one.
 */
export const defaultGrantTtlInDays = 180;
export const grantTtlEnvKey = 'OIDC_GRANT_TTL_DAYS';
/**
 * Parse the configured Grant TTL. A value that is not a positive whole number of days throws,
 * so a typo stops the server at start-up instead of silently running with the default.
 */
export const parseGrantTtlInDays = (raw) => {
    const value = raw?.trim();
    if (!value) {
        return defaultGrantTtlInDays;
    }
    const days = Number(value);
    if (!/^\d+$/.test(value) || !Number.isSafeInteger(days) || days < 1) {
        throw new TypeError(`${grantTtlEnvKey} must be a positive whole number of days, got ${JSON.stringify(raw)}`);
    }
    return days;
};
export const grantTtlInDays = parseGrantTtlInDays(typeof process === 'undefined' ? undefined : process.env[grantTtlEnvKey]);
